import clsx from 'clsx'
import React from 'react'
import ReactPlayer from 'react-player/lazy'

import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg'
import { FullScreenModal } from 'components/uikit/FullScreenModal/FullScreenModal'
import { Icon } from 'components/uikit/Icon/Icon'

import styles from './VideoModal.module.scss'

interface VideoModalProps {
  show: boolean
  setShow: (show: boolean) => void
  videoSrc: string
  setPlayVideo: (playVideo: boolean) => void
  playVideo: boolean
}

const VideoModal = ({ show, setShow, videoSrc, playVideo, setPlayVideo }: VideoModalProps) => {
  const [hover, setHover] = React.useState(false)

  const handleHover = () => {
    setHover(!hover)
  }

  return (
    <FullScreenModal open={show} className={styles.videoModal}>
      <div slot="header" className={styles.videoModalHeader}>
        <button
          onMouseEnter={handleHover}
          onMouseLeave={handleHover}
          onClick={() => {
            setPlayVideo(false)
            setShow(false)
          }}
        >
          <Icon
            icon={CloseIcon}
            className={clsx(styles.closeIcon, hover && styles.showCursor)}
            fill="#4C4C4C"
            color="#4C4C4C"
          />
        </button>
      </div>
      <div slot="body" className="relative h-full">
        <ReactPlayer
          url={videoSrc}
          playing={playVideo}
          controls={true}
          width="100%"
          height="100%"
          className={styles.videoPlayer}
        />
      </div>
      <div slot="actions" />
    </FullScreenModal>
  )
}

export default VideoModal
